import React from 'react'
import ReactDOM from 'react-dom'
import { App } from './components/apps/app'

ReactDOM.render(<App />, document.querySelector('#root'))
